<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'GenericRadarChart',

  props: {
    config: {
      type: Object,
      required: true
    },

    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      chartRefId: `radar-chart-${this._uid}`,
      chartInstance: null
    };
  },

  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.updateChart();
      }
    },

    data: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },

  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);
      this.updateChart();
    },

    buildOption() {
      var categoryField = this.config.categoryField;
      var valueField = this.config.valueField;

      var data = this.data || [];

      var i;
      var row;
      var indicators = [];
      var values = [];
      var maxValue = 0;

      // ---- ALWAYS compute dynamic max ----
      for (i = 0; i < data.length; i++) {
        row = data[i];
        var v = Number(row[valueField]);

        if (!isNaN(v) && v > maxValue) {
          maxValue = v;
        }
      }

      // optional: avoid all-zero charts looking flat
      if (maxValue === 0) {
        maxValue = 1;
      }

      // ---- build indicators + values ----
      for (i = 0; i < data.length; i++) {
        row = data[i];

        var val = Number(row[valueField]);
        if (isNaN(val)) val = 0;

        indicators.push({
          name: row[categoryField],
          max: maxValue
        });

        values.push(val);
      }

      return {
        title: {
          text: this.config.title || '',
          left: 'center'
        },

        tooltip: {},

        radar: {
          indicator: indicators,
          radius: this.config.radius || '65%'
        },

        series: [
          {
            name: this.config.seriesName || 'Values',
            type: 'radar',

            data: [
              {
                value: values,
                name: this.config.seriesName || 'Values'
              }
            ],

            areaStyle: {
              opacity: 0.2
            },

            itemStyle: {
              color: "#FFD38A"
            }
          }
        ]
      };
    },

    updateChart() {
      if (!this.chartInstance) return;

      this.chartInstance.setOption(
        this.buildOption(),
        true
      );
    },

    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },

    getChartInstance() {
      return this.chartInstance;
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);

    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>